<template>
  <b-card title="Panel de Conflictos">
    <b-alert :show="conflicts.length === 0" variant="success">
      ¡Felicidades! No se han detectado conflictos en los horarios.
    </b-alert>

    <b-list-group v-if="conflicts.length > 0">
      <b-list-group-item v-for="(conflict, index) in conflicts" :key="index" variant="danger">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <feather-icon icon="AlertTriangleIcon" class="mr-1" />
            <strong>{{ conflict.type }}:</strong> {{ conflict.message }}
          </div>
          <small>{{ conflict.time }}</small>
        </div>
      </b-list-group-item>
    </b-list-group>
  </b-card>
</template>

<script>
import {
  BCard, BAlert, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import moment from 'moment'

export default {
  components: {
    BCard,
    BAlert,
    BListGroup,
    BListGroupItem,
  },
  data() {
    return {
      // Datos simulados. En una app real, vendrían del store o de una API.
      events: [
        { id: 1, start: '2024-08-26 08:00', end: '2024-08-26 10:00', title: 'Programación I', teacherId: 1, split: 1 },
        { id: 2, start: '2024-08-26 09:00', end: '2024-08-26 11:00', title: 'Matemática I', teacherId: 2, split: 1 }, // Conflicto de salón
        { id: 3, start: '2024-08-26 11:00', end: '2024-08-26 13:00', title: 'Bases de Datos', teacherId: 1, split: 2 },
        { id: 4, start: '2024-08-26 11:30', end: '2024-08-26 13:30', title: 'Programación II', teacherId: 1, split: 3 }, // Conflicto de docente
      ],
      teachers: { 1: 'Juan Pérez', 2: 'María García' },
      classrooms: { 1: 'Salón 101', 2: 'Salón 102', 3: 'Salón 103' },
      conflicts: [],
    }
  },
  created() {
    this.detectConflicts()
  },
  methods: {
    detectConflicts() {
      const detected = []
      const format = 'YYYY-MM-DD HH:mm'
      const events = this.events.map(e => ({ ...e, start: moment(e.start, format), end: moment(e.end, format) }))

      for (let i = 0; i < events.length; i++) {
        for (let j = i + 1; j < events.length; j++) {
          const e1 = events[i]
          const e2 = events[j]

          const overlap = e1.start.isBefore(e2.end) && e1.end.isAfter(e2.start)

          if (overlap) {
            const timeRange = `${e1.start.format('HH:mm')}-${e1.end.format('HH:mm')} vs ${e2.start.format('HH:mm')}-${e2.end.format('HH:mm')}`
            if (e1.split === e2.split) {
              detected.push({
                type: 'Conflicto de Salón',
                message: `El salón ${this.classrooms[e1.split]} está ocupado por "${e1.title}" y "${e2.title}".`,
                time: timeRange,
              })
            }
            if (e1.teacherId && e2.teacherId && e1.teacherId === e2.teacherId) {
              detected.push({
                type: 'Conflicto de Docente',
                message: `El docente ${this.teachers[e1.teacherId]} tiene asignadas las clases "${e1.title}" y "${e2.title}" al mismo tiempo.`,
                time: timeRange,
              })
            }
          }
        }
      }
      this.conflicts = detected
    },
  },
}
</script>
